'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isTestEnv = process.env.NODE_ENV === 'test';

exports.isTestEnv = isTestEnv;
//# sourceMappingURL=isTestEnv.js.map
